// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
import DateTime from '../../common/DateTime/DateTime';
interface DatePickerProps {
    onChange: (time: string) => void;
    height?: string;
    value?: string;
    width?: string;
    dateFormat?: string;
}

class DatePicker extends React.Component<DatePickerProps, any> {
    _datePickerRef = createRef<HTMLInputElement>();
    constructor(props: DatePickerProps) {
        super(props);
    }

    private _setOptions = (props: DatePickerProps) => {
        let container = $(this._datePickerRef.current) as any;
        let options: any = {
            change: function () {
                props.onChange(this.getValue());
            },
            dateFormat: InovxLoader.getLocaleData().datePattern,
            locale: InovxLoader.getSyncfusionLocale()
        }

        if (props.height) {
            options.height = props.height;
        }

        if (props.width) {
            options.width = props.width;
        }

        if (props.value) {

            options.value = new DateTime({ date: props.value, dateOptions: null, forceShowSeconds: false, ignoreTime: true, timeOptions: null, convertToTimezone : false });
        }

        if (props.dateFormat) {
            options.dateFormat = props.dateFormat;
        }

        container.ejDatePicker(options);
    }

    componentDidMount() {
        this._setOptions(this.props);
    }

    componentWillUnmount() {
        let container = $(this._datePickerRef.current) as any;
        container.ejDatePicker("destroy");
    }

    render() {
        return <input type="text" id="datepicker" ref={this._datePickerRef} />
    }
}

export default DatePicker;